<template>
	<Row class="page-container-row">
		<Col
			:span="24"
			:offset="0"
			:lg="{ span: 18, offset: 3 }"
			:xl="{ span: 12, offset: 6 }"
		>
			<VerticalLayout>
				<PageContainer :withCloseButton="false">
					<TypographyTitle :level="2" class="align-center">{{ $t('not-found-page.title') }}</TypographyTitle>
					<TypographyParagraph class="align-center">{{ $t('not-found-page.text') }}</TypographyParagraph>
					<Button block type="link" href = "/" > {{ $t('not-found-page.homePage') }}</Button>
				</PageContainer>
			</VerticalLayout>
		</Col>
	</Row>
</template>

<script>
import { Row, Col, TypographyTitle, TypographyParagraph, Button } from 'ant-design-vue';

import VerticalLayout from '@/components/common/VerticalLayout.vue';
import PageContainer from '@/components/common/PageContainer.vue';

export default {
	components: {
		Row, Col, Button,
		TypographyTitle, TypographyParagraph,
		PageContainer, VerticalLayout,
	}
}
</script>
